import { memo } from 'react';
import { RedesignSponsorshipTerms } from 'root/src/client/v2/_pages/drop/redesign/RedesignSponsorshipTerms';
import { sponsorshipRegularTerms } from 'root/src/shared/descriptions/modules/howToEarnPointsModal';
import { formatNumberWithCommas } from 'root/src/shared/util/formatNumberWithCommas';
import { useDropShortUrl } from 'root/src/client/v2/drop/hooks/useDropShortUrl';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
export const RedesignHowToEarnPointsModal = memo(({ drop }) => {
    var _a;
    const modal = useRedesignModal();
    const shortUrlQuery = useDropShortUrl({ dropId: drop.id });
    return (<RedesignModalShell className="sm:max-w-lg">
			<div className="flex w-full flex-col items-center gap-1 text-center">
				<h2 className="font-display text-xl font-bold text-foreground">How to earn points</h2>
				{drop.estimatedPointsToEarn ? (<p className="text-sm font-semibold text-neon-cyan">Earn up to {formatNumberWithCommas(drop.estimatedPointsToEarn)} points on this drop</p>) : (<p className="text-sm text-muted-foreground">Follow the steps below to earn points.</p>)}
			</div>

			<div className="w-full rounded-xl border border-solid border-white/[0.06] bg-white/[0.02] p-4">
				<RedesignSponsorshipTerms terms={sponsorshipRegularTerms} dropEvent={drop} shortUrl={(_a = shortUrlQuery.data) !== null && _a !== void 0 ? _a : ''} canEarnPoints isTermsAccepted={false} canUserReclaimReservation={false}/>
			</div>

			<Button variant="brand" onClick={modal.hide} className="w-full max-w-xs rounded-lg text-sm font-semibold">
				Got it
			</Button>
		</RedesignModalShell>);
});
